import React, { useState } from "react";
import PageHeaderContent from "../../components/pageHeaderContent";
import { BsInfoCircleFill } from "react-icons/bs";
import { Animate } from "react-simple-animate";
import "./styles.scss";
import emailjs from "@emailjs/browser";

/*
  Contact page — EmailJS wired directly with provided credentials.
  Service ID: service_57r0pm8
  Template ID: template_6m0vppg
  Public Key: j7msxSxi5p2yKLLKK

  WARNING: These keys are present in the source because you asked to include changed files.
  For production, prefer environment variables (REACT_APP_...) and do NOT commit real keys.
*/

const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || '';
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '';
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '';

const contactLinks = [
  {
    label: "Email",
    value: "thakare607@gmail.com",
    href: "mailto:thakare607@gmail.com",
  },
  {
    label: "LinkedIn",
    value: "shubham thakare",
    href: "https://www.linkedin.com/in/shubhamthakarecode/"
  }
];

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState({ loading: false, success: null, message: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const sendViaEmailJS = async () => {
    setStatus({ loading: true, success: null, message: "" });

    if (!EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID || !EMAILJS_PUBLIC_KEY) {
      setStatus({ loading: false, success: false, message: "EmailJS not configured." });
      return;
    }

    const templateParams = {
      from_name: form.name,
      from_email: form.email,
      message: form.message,
      time: new Date().toLocaleString(),
      page_url: window.location.href,
    };

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );
      setStatus({ loading: false, success: true, message: "Message sent via EmailJS — thanks!" });
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setStatus({ loading: false, success: false, message: "EmailJS error — please try again later." });
      console.error("EmailJS error:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setStatus({ loading: false, success: false, message: "Please fill all fields." });
      return;
    }
    await sendViaEmailJS();
  };

  return (
    <div className="contact-container">
      <PageHeaderContent icon={<BsInfoCircleFill />} heading="Contact" subheading="Get in touch" />

      <div className="contact-grid">
        <Animate play duration={0.6} delay={0.2} start={{ transform: 'translateX(-30px)', opacity: 0 }} end={{ transform: 'translateX(0)', opacity: 1 }}>
          <div className="contact-card">
            <h3>Contact</h3>
            <p>If you'd like to reach out directly, use the form or the links below.</p>
            <ul className="contact-links">
              {contactLinks.map((c) => (
                <li key={c.label}><strong>{c.label}:</strong> <a href={c.href} target="_blank" rel="noreferrer">{c.value}</a></li>
              ))}
            </ul>
          </div>
        </Animate>

        <Animate play duration={0.6} delay={0.4} start={{ transform: 'translateX(30px)', opacity: 0 }} end={{ transform: 'translateX(0)', opacity: 1 }}>
          <div className="contact-form-card">
            <h3>Send a message</h3>

            <form onSubmit={handleSubmit} className="contact-form">
              <label>Name</label>
              <input name="name" value={form.name} onChange={handleChange} placeholder="Your name" />

              <label>Email</label>
              <input name="email" value={form.email} onChange={handleChange} placeholder="you@domain.com" type="email" />

              <label>Message</label>
              <textarea name="message" value={form.message} onChange={handleChange} placeholder="Write your message" rows={6} />

              <button type="submit" className="btn-primary" disabled={status.loading}>{status.loading ? 'Sending...' : 'Send'}</button>
            </form>

            {status.message && (
              <div className={`contact-status ${status.success ? 'success' : 'error'}`}>{status.message}</div>
            )}

            <div className="contact-hint">
              <small>
                Tip: make sure to check your spam folder if you don't see a reply!
              </small>
            </div>
          </div>
        </Animate>
      </div>
    </div>
  );
}
